import { Controller } from "@hotwired/stimulus";

import { post } from "../lib/http.js";
import { showToast } from "../lib/toast.js";

/**
 * Кнопка подписки на читателя.
 *
 * Сервер сам решает, подписка это или отписка, и возвращает новое состояние —
 * клиенту незачем его угадывать. Счётчик подписчиков, если он есть на странице,
 * обновляется по таргету, а не поиском по классам вверх по дереву.
 */
export default class extends Controller {
  static targets = ["button", "count"];
  static values = {
    url: String,
    userId: Number,
    following: Boolean,
  };

  async toggle() {
    this.buttonTarget.disabled = true;

    try {
      const data = await post(this.urlValue, { user_id: this.userIdValue });
      this.followingValue = data.status === "followed";
      this.render(data.followers_count);
    } catch (error) {
      showToast(error.message);
    } finally {
      this.buttonTarget.disabled = false;
    }
  }

  render(followersCount) {
    const button = this.buttonTarget;
    button.textContent = this.followingValue ? "Отписаться" : "Подписаться";
    button.classList.toggle("btn--ghost", this.followingValue);
    button.classList.toggle("btn--accent", !this.followingValue);

    if (this.hasCountTarget && followersCount !== undefined) {
      this.countTarget.textContent = followersCount;
    }
  }
}
